<template>
  <el-radio-group v-model="val">
    <template v-for="(label,idx) in list">
      <el-radio :label="label.value" :key="label.value" :style="radioStyle" v-if="!label.id">{{ label.label }}
      </el-radio>
      <el-radio :label="label.value" :key="label.value"
                :style="radioStyle" v-if="label.id">
        {{ label.pre }}{{ label.label }}<input
          type="text" :style="{width:label.width}" v-model="inputVal[idx]">{{ label.suf }}
      </el-radio>
    </template>
  </el-radio-group>
</template>

<script>
export default {
  name: "staff-radio-group",
  props: {
    data: Array,
    value: [String, Number],
    radioStyle: {
      type: Object,
      default: () => {
        return {
          lineHeight: '28px'
        }
      }
    },
    mapKey: {
      type: Object,
      default: () => {
        return {
          value: 'value',
          label: 'label'
        }
      }
    }
  },
  data() {
    return {
      val: '',
      inputVal: []
    }
  },
  computed: {
    list() {
      const {data = [], mapKey} = this;
      return data.map((r, i) => {
        if (typeof r === 'string') return {
          label: r,
          value: i
        }
        return {
          value: r[mapKey.value] || i,
          label: r[mapKey.label],
          ...r
        }
      })
    }
  },
  watch: {
    value(newV) {
      if (this.val !== newV)
        this.val = newV;
      this.initInputVal();
    },
    val(newV) {
      this.$emit('input', newV)
    },
    inputVal(newV) {
      let obj = {};
      newV.forEach((r, i) => {
        let extra = this.list[i];
        obj[extra.id] = r;
      });
      this.$emit('inputChange', obj);
    }
  },
  created() {
    this.val = this.value;
    this.initInputVal();
  },
  methods: {
    initInputVal() {
      if (this.data)
        this.data.forEach((rr, i) => {
          this.inputVal.splice(i, 1, rr.data || '');
        })
    }
  },
}
</script>

<style scoped lang="scss">
input {
  border: 0px none;
  width: 60px;
  border-bottom: 1px #cccccc solid;
  padding: 0px 5px;
  outline: none;
}
</style>